import { useNavigation } from '@react-navigation/core';
import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import { handlePermitNavigation } from 'utils/permitUtils';
import TicketRow from '../permitRows/TicketRow';

const AccessPermit = ({
  permit,
}: {
  permit: UnifiedPermit;
}): JSX.Element | null => {
  const { navigate } = useNavigation<RootNavProps>();
  const { t } = useTranslation();
  if (!permit.permitType || permit.permitType !== 'ACCESS') {
    return null;
  }

  const poolingGroups = permit.accessPermitPoolingGroupInfo;
  if (!poolingGroups) {
    return null;
  }

  // Case: Multiple pooling groups
  if (poolingGroups.length > 1) {
    return (
      <>
        {poolingGroups.filter(Boolean).map(
          (poolingGroup) =>
            poolingGroup && (
              <TicketRow
                key={`pooling-group-${poolingGroup.uid}`}
                title={
                  (poolingGroup.parkingZoneName ||
                    poolingGroup.salesLocationName) ??
                  ''
                }
                divider={true}
                content={
                  !poolingGroup.capacityHidden
                    ? t('permit.access.spot', {
                        count: poolingGroup?.freePoolingSpots ?? 0,
                      })
                    : t('permit.access.no_spot_data')
                }
              />
            )
        )}
        <TicketRow
          titleColor={theme.colors.black}
          title={t('services.viewDetails')}
          divider={false}
          onPress={() => {
            handlePermitNavigation(permit, navigate);
          }}>
          <Icon
            name="Chevron_Right"
            size="s"
            testID={`permit-${permit.id}-view-details`}
          />
        </TicketRow>
      </>
    );
  }

  // Case: Single pooling group
  if (poolingGroups.length === 1) {
    //We can take just the first pool, as this component is for the single pool case.
    const poolingGroup = poolingGroups[0];

    return (
      <>
        {!poolingGroup?.capacityHidden && (
          <TicketRow
            title={t('permit.access.availability')}
            divider={false}
            content={t('permit.access.spot', {
              count: poolingGroup?.freePoolingSpots ?? 0,
            })}
          />
        )}
      </>
    );
  }
  return null;
};

export default AccessPermit;
